<template>
  <v-card flat>
    <v-card-text>
      <!-- HTML文件 -->
      <div v-html="htmlCode"></div>
    </v-card-text>
  </v-card>
</template>
<script>
import { userFileChapterHtml, userFileRead } from '@/plugins/api';
export default {
  props: ['param'], // 文件读取参数:fileReadParam
  data () {
    return {
      htmlCode: '',
      jsCode: '',
      projectInfo: null
    }
  },
  async mounted () {
    await this.init();
  },
  methods: {
    async init () {
      await userFileRead({ path: `/${this.param.type}/${this.param.xmh}/Design/Project_Information.xlsx` }).then(res => {
        let d = res.data;
        if (!d) d = [[], [], []];
        this.projectInfo = d; // 项目名称,委托单位,项目编号,完成日期
        this.projectInfo[3] = ['项目完成日期', this.param.xmwcrq];
      });
      await userFileChapterHtml({ path: `${this.param.type}/cover.html` }).then(res => {
        let d = res.data;
        this.htmlCode = d.replace(/<script.*?>([\s\S]+)<\/script>/, (a, b) => {
          this.jsCode = b;
          return '';
        });
      })
      await this.runJsCode();
    },
    async runJsCode () {
      if (this.jsCode) await new Function('ξ', this.jsCode)(this)
    }
  }
}
</script>